(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){

      
    
    //-------------------------------------
 

    //BEGIN product page accordion
	$(".m_accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("m_accordion-active")) {
			$(".m_accordion__content").slideUp(400);
			$(".m_accordion__title").removeClass("m_accordion-active").attr("aria-expanded", "false");
			$('.m_accordion__arrow').removeClass('m_accordion__rotate');
		}

		$this.toggleClass("m_accordion-active");
		$this.attr("aria-expanded", $this.hasClass("m_accordion-active") ? "true" : "false");
		$this.next().slideToggle();
		$('.m_accordion__arrow',this).toggleClass('m_accordion__rotate');
	});
	//END



  $(".list-item-inner").on("click", function(event){
      event.preventDefault();
      var data_url = $(this).attr("data-url");
      window.location.href = data_url;
      //alert(data_url);
      return false;
    });

    
    $(".filters_resert_container a").on("click", function(event){
      event.preventDefault();
      var c_url='/collections/all';      
      if (window.location.href.indexOf("filter.p.tag") > -1) {
        //alert();
        c_url=$(this).attr('href');
      }
      //alert(c_url);
      window.location.href = c_url;
      return false;
    });



    
    if (window.matchMedia('(min-width: 721px)').matches) {        
      document.getElementById("s-my-modal").style.display = "none";
    }else{
      if ($(".faceted__filters-title").hasClass("clk_filter")) {        
      }else{
        $(".faceted__filters-title").addClass('clk_filter');
      }
      $("body").on('click', '.clk_filter', function() {
          document.getElementById("s-my-modal").style.display = "block";
      });
    }

    $(window).on('resize', function(){
      var win = $(this);     
      if (win.width() >= 720) {
        document.getElementById("s-my-modal").style.display = "none";
        if ($(".faceted__filters-title").hasClass("clk_filter")) {          
          $(".faceted__filters-title").removeClass('clk_filter');
        }        
      }else{
        if ($(".faceted__filters-title").hasClass("clk_filter")) {        
        }else{
          $(".faceted__filters-title").addClass('clk_filter');
        }
        $("body").on('click', '.clk_filter', function() {
            document.getElementById("s-my-modal").style.display = "block";
        });        
      }
  });



///cart page zhone change
    $("#shipping-zone").change(function () {
        //var end = this.value;
        //var firstDropVal = $('#pick').val();
      //alert(this.value);
    });
    
    
    
    
    
    //--------------------------------------
   
  };

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.js', function(){
      jQuery = jQuery.noConflict(true);
      myCode(jQuery);
    });
  } else {
    myCode(jQuery);
  }

})();